export default __webpack_public_path__ + "static/media/boom1.4d436099.svg";